import { Routes } from '@angular/router';

import { LoginGuard } from '../login/login-guard';
import { MapViewComponent } from '../map-view/map-view.component';
import { AdminComponent } from '../admin/admin.component';

import { LoginComponent } from '../login/login.component';

export const appRoutes: Routes = 
[
  
      { path: '', component: LoginComponent},
      { path: 'map/:view', component: MapViewComponent ,canActivate: [LoginGuard] },   
      { path: 'admin', component: AdminComponent ,canActivate: [LoginGuard] }, 
      { path: 'login', component: LoginComponent  },
     // { path: '**', redirectTo: '/'}
  
];
